module.exports = __webpack_public_path__ + "static/media/eating.a4d98bca.gif";